import Heading from 'components/design-system/Heading/Heading';
import Text from 'components/design-system/Text/Text';

export const Cuerpo = ({ data, children }) => {
  console.log(data);
  return (
    <div className="bg-white rounded shadow-md p-4 pb-24 sm:px-10 sm:pt-10 relative mb-16">
      <div className="w-full md:w-4/5 mb-10">
        <Heading type="h2">Conceder acceso de administración</Heading>
        <Text size="M">
          El usuario <strong>{data.solicitante.nombreUsuario}</strong>,
          perteneciente al negocio{' '}
          <strong>{data.solicitante.nombreEmpresa}</strong>, te ha invitado a
          registrarte en la <strong>Plataforma de Industria Circular</strong> y
          ha solicitado autorización para{' '}
          <strong>administrar tu negocio</strong>.
          <br />
          Para continuar, debes{' '}
          <strong>aceptar los términos y condiciones </strong>
          y, a continuación, realizar el{' '}
          <strong>registro de tu cuenta de usuario.</strong>
          <br />
          Si decides <strong>no aceptar los términos</strong>, puedes{' '}
          <strong>rechazar la solicitud.</strong>
        </Text>
      </div>
      {children}
    </div>
  );
};
